/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper } from '@ember/component/helper';

export default helper(function absoluteUrl(relativePath) {
  let { protocol, host } = window.location;
  return `${protocol}//${host}${relativePath}`;
});
